import axios from "axios";
import { getCookie } from "./cookie";
import getAccessToken from "../services/getAccessToken";

export const getData = async (url) => {
  try {
    console.log("get data url",url)
    let token = getCookie("access_token")
    if (!token) {
      token = await getAccessToken();
    }
    // console.log("env loaded is:-",import.meta.env.VITE_APP_ENV)
    url = `${process.env.REACT_APP_API_URL}${url}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    return { isSuccess: false, error };
  } finally {
  }
};

export const postData = async (url, payload, method = "POST", headers = {}) => {

  try {
    let token = getCookie("access_token")
    if (!token) {
      token = await getAccessToken();
    }
    url = `${process.env.REACT_APP_API_URL}${url}`;

    const response = await axios({
      method,
      url,
      data: payload,
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch ({ response, request, message }) {
    let errorMessage = "An unknown error occurred";

    if (response) {
      // Server responded with a status other than 2xx
      errorMessage =
        response.data?.message ||
        `Error ${response.status}: Something went wrong`;
    } else if (request) {
      // Request was made but no response received
      errorMessage = "No response from server. Please try again.";
    }
    return { isSuccess: false, message: errorMessage }; // Returning error message
  } finally {
  }
};
